export enum UserAdminLevel {
  INACTIVE_USER = 0,
  USER = 1,
  ADMIN = 2,
  //   TRI = 3,
  SUPERADMIN = 4,
}
